import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { Accordion, Button, Form, Grid, Icon } from 'semantic-ui-react';
import { Filter, Main } from 'Containers';
import { SelectField } from 'Common/SemanticWrapper';
import { FilterEnum } from 'Common/FieldEnum';
import { makeOptionsData } from 'Common/FormHelper';
import { GenericFiltersContainer } from 'Components/filters/container';
import { caseInsensitiveFilter } from 'Common/GridHelper';

const KitchenItemsComponent = props => {
  const {
    activeIndexForFilter,
    handleClick,
    assignItemsBidGroupData,
    assignItemsItemGroupData,
    handleChange,
    filterValues,
    clearFilters,
    kitchenItems,
    fetchKitchenItemsLoading,
    getMainProps,
    sorted,
    onSortedChange,
    filtered,
    onFilteredChange,
    columns,
    reactTableRef,
    page,
    onPageChange,
  } = props;
  const bidGroupOptions = makeOptionsData(assignItemsBidGroupData);
  const itemGroupOptions = makeOptionsData(assignItemsItemGroupData);
  const fields = [
    {
      name: FilterEnum.GroupId_Item,
      component: SelectField,
      type: 'text',
      options: itemGroupOptions,
      label: 'ITEM GROUP',
    },
    {
      name: FilterEnum.GroupId_Bid,
      component: SelectField,
      type: 'text',
      options: bidGroupOptions,
      label: 'BID GROUP',
      maxLength: 20,
    },
  ];

  return (
    <Fragment>
      <Filter title={'Manage Kitchen Items'} />
      <Main {...getMainProps()} shouldNotUsePageWidth>
        <Form>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Accordion fluid styled>
                  <Accordion.Title
                    active={!activeIndexForFilter}
                    onClick={handleClick}
                  >
                    <Icon name="dropdown" />
                    <span className="text-orange">Filter By</span>
                  </Accordion.Title>
                  <Accordion.Content active={!activeIndexForFilter}>
                    <Grid className={'remove-spacing'}>
                      <GenericFiltersContainer
                        fields={fields}
                        onChange={handleChange}
                        filterValues={filterValues}
                      />
                      <Grid.Row>
                        <Grid.Column>
                          <Button
                            className={'clear-filters-button'}
                            content="Clear Filters"
                            onClick={clearFilters}
                            type={'button'}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Accordion.Content>
                </Accordion>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column style={{ paddingTop: 20 }}>
                <ReactTable
                  minRows={0}
                  data={kitchenItems}
                  noDatatext={'No rows found'}
                  resizable={false}
                  className="-striped -highlight modalGrid"
                  columns={columns}
                  defaultFilterMethod={caseInsensitiveFilter}
                  loading={fetchKitchenItemsLoading}
                  sorted={sorted}
                  onSortedChange={onSortedChange}
                  filtered={filtered}
                  onFilteredChange={onFilteredChange}
                  ref={reactTableRef}
                  page={page}
                  onPageChange={onPageChange}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Main>
    </Fragment>
  );
};

KitchenItemsComponent.propTypes = {
  columns: PropTypes.array.isRequired,
  activeIndexForFilter: PropTypes.number,
  handleClick: PropTypes.func,
  assignItemsBidGroupData: PropTypes.array,
  assignItemsItemGroupData: PropTypes.array,
  handleChange: PropTypes.func,
  filterValues: PropTypes.object,
  clearFilters: PropTypes.func,
  kitchenItems: PropTypes.array,
  fetchKitchenItemsLoading: PropTypes.bool,
  getMainProps: PropTypes.func,
  sorted: PropTypes.array,
  filtered: PropTypes.array,
  onSortedChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
  reactTableRef: PropTypes.object,
  page: PropTypes.number,
  onPageChange: PropTypes.func,
};

export default KitchenItemsComponent;



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenitems/components/KitchenItemsComponent.js